import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, finalize, map, startWith, tap } from 'rxjs';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Cerere, DocumentCetatean, RequestMessageInternPayload, RequestMessageNotitaPayload, RequestMessageToCetateanPayload, Coleg, HistoryEntry } from '../cereri.interface';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { AppFilesService } from 'src/app/services/app-files.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonService } from 'src/app/services/common.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ModalInchidereLucrareComponent } from './modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { SabloaneComponent } from './sabloane/sabloane.component';
import { requireMinOneColleagueValidator } from 'src/app/validators/at-least-one-colleague';
import { PermissionsService } from 'src/app/services/permissions.service';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';

@Component({
    selector: 'app-cereri-detalii',
    templateUrl: './cereri-detalii.component.html',
    styleUrls: ['./cereri-detalii.component.scss']
})
export class CereriDetaliiComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    istoric: HistoryEntry[] = [];

    selectedDocTypeKey!: string;

    token!: string;
    isLoading = false;
    isActualizareCerereLoading = false;
    isDocumentOficialDisabled = false;
    selectedDocGenerabilToggle = 'active';
    selectedDocToggle = 'cereri';
    //selectedMessageToggle = 'cetatean';
    selectedMessagingToggle = 'internalMsg';
    selectedInfoExtra = 'info';
    selectedPFStatus = 'info';
    passedRequestId!: number;
    directii!: any[];
    statusCerere!: any[];
    prioritateCerere!: any[];

    helper = helper;
    editorConfig!: AngularEditorConfig;
    safeHtml!: SafeHtml;

    showSignatures: any;
    cerere!: Cerere | null;
    informatii_aditionale: any = this.cerere?.informatii;
    documenteCetatean!: DocumentCetatean[];
    documentCategories!: any[];

    sendMessageCetateanForm!: FormGroup;
    sendMessageInternForm!: FormGroup;
    sendMessageNotitaForm!: FormGroup;
    notifyAnswer!: FormGroup;

    uploadedFileNames: string[] = [];

    showValidateCard: boolean = true;

    user: any = null;

    defaultChoiceParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    responseTimes = [
        { key: '3', value: 3 },
        { key: '5', value: 5 },
        { key: '7', value: 7 },
        { key: '10', value: 10 },
    ];

    slugsForDocGenerate: string[] = [
        'cerere_certificat_de_atestare_fiscala_persoane_fizice',
        'cerere_certificat_de_atestare_fiscală_persoane_juridice',
    ]

    uploading: any = {
        files_mesagerie_cetatean: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    files: any = {
        files_mesagerie_cetatean: [],
        files_mesagerie_intern: [],
        files_mesagerie_notita: [],
    };
    hasDraft!: boolean;
    // Add coleagues functionality

    separatorKeysCodes: number[] = [ENTER, COMMA];
    filteredColeagues!: any;
    coleagues: Coleg[] = [];
    allColeagues: Coleg[] = [];
    coleaguesCtrl = new FormControl('');

    @ViewChild('coleagueInput') coleagueInput!: ElementRef<HTMLInputElement>;

    // Subscription to track our sabloane added from the button below messaging component
    private contentSubscription!: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<CereriDetaliiComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private authService: AuthService,
        private commonService: CommonService,
        private fb: FormBuilder,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private appFileService: AppFilesService,
        public toastr: ToastrService,
        public permissionsService: PermissionsService,
    ) {
        this.processToken();
        this.passedRequestId = this.data.cerere.id_cerere;
        this.directii = this.data.directii;
        this.statusCerere = this.data.statusCerere;
        this.prioritateCerere = this.data.prioritateCerere;
    }

    processUserDetails() {
        const userObj = this.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    ngOnInit(): void {
        const htmlFromBackend = `<span><span class='fa fa-clock-o'></span> 30z</span> <span class='green-text'><b>27z 21h </b></span>`;
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlFromBackend);

        this.getRequestInfo();
        this.editorConfig = initializeEditor();
        this.getUsersActive();
        this.initializeCetateanForm();
        this.initNotifyAnswer();
        this.subscribeToContent();

        this.sendMessageInternForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl(2),
            coleagues: new FormControl(this.coleagues, requireMinOneColleagueValidator()),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
        this.sendMessageNotitaForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl(3),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });

        this.filteredColeagues = this.coleaguesCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value ? this._coleaguesFilter(value) : this.allColeagues.slice()
            )
        );
    }

    ngOnDestroy(): void {
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
    }

    initNotifyAnswer() {
        this.notifyAnswer = new FormGroup({
            notify_date_expire: new FormControl('', [Validators.required]),
        });
    }

    initializeCetateanForm() {
        this.sendMessageCetateanForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl(1),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
    }

    // This subscribes to any content change coming from Sabloane button below
    subscribeToContent() {
        this.contentSubscription = this.cereriService.sablonContent$.subscribe({
            next: (content) => {
                this.updateMessageFormControl(content);
            },
        });
    }

    // This updated our form control
    updateMessageFormControl(content: string) {
        // Update the 'message' form control with the new content
        this.sendMessageCetateanForm.controls['message'].setValue(content);
    }

    getDocumentTypeKeys(): string[] {
        return this.cerere ? Object.keys(this.cerere.documente || {}) : [];
    }

    getDocumentKeys(docTypeKey: string): string[] {
        if (this.cerere && this.cerere.documente && this.cerere.documente[docTypeKey]) {
            return this.cerere.documente[docTypeKey].items.map(item => item.old_name);
        }
        return [];
    }

    // prepareDocumentCategories(): void {
    //     if (this.cerere && this.cerere.documente) {
    //         this.documentCategories = Object.keys(this.cerere.documente).map(
    //             (key) => this.cerere?.documente[key]
    //         );
    //     }
    // }

    handleButtonClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'validează':
                this.confirmValidareSolicitare();
                break;
            case 'invalidează':
                this.showValidateCard = false;
                this.confirmInValidareSolicitare();
                break;
            case 'anulare':
            case 'clasare':
                this.confirmAnulareSolicitare();
                break;
            case 'închidere lucrare':
                if (this.cerere) {
                    this.openInchidereSolicitare(this.cerere);
                }
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    handleButtonResetClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'validează':
                this.resetValidareCerere();
                break;
            case 'invalidează':
                this.resetinValidareCerere();
                break;
            case 'anulare':
            case 'clasare':
                this.resetClasareCerere();
                break;
            case 'închidere lucrare':
                this.resetInchidereCerere();
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    getRequestInfo(boolean = true, istoricBoolean = true) {
        this.isLoading = boolean;
        this.cereriService
            .getRequestById(this.passedRequestId)
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.isLoading = false;
                this.cerere = requestData;
                console.log(requestData);
                this.hasDraft = requestData.hasDraft;
                this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
                    (this.cerere as Cerere).sla
                );
                if (
                    typeof this.cerere?.generabile !== 'undefined' &&
                    this.cerere.generabile.length > 0
                ) {
                    this.showSignatures = this.cerere.generabile[0].id_document;
                }

                this.getIstoric(istoricBoolean);
                this.selectedDocTypeKey = this.getDocumentTypeKeys()[0];
            });
    }

    // Coleagues section

    private _coleaguesFilter(value: string | Coleg): Coleg[] {
        let filterValue = '';
        if (typeof value === 'string') {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        }

        return this.allColeagues.filter((coleague) =>
            coleague.name.toLowerCase().includes(filterValue)
        );
    }

    addColeague(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            const foundOption = this.allColeagues.find(
                (coleague) => coleague.name.toLowerCase() === value.toLowerCase()
            );
            if (foundOption) {
                this.coleagues.push(foundOption);
                this.sendMessageInternForm.controls['coleagues'].setValue([...this.coleagues]);
                this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
            }
        }

        event.chipInput!.clear();
        this.coleaguesCtrl.setValue(null);
    }

    removeColeague(coleague: Coleg): void {
        const index = this.coleagues.indexOf(coleague);

        if (index >= 0) {
            this.coleagues.splice(index, 1);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([...this.coleagues]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    selectedColeagues(event: MatAutocompleteSelectedEvent): void {
        const selectedOption = this.allColeagues.find(
            (coleague) => coleague.name === event.option.viewValue
        );
        if (
            selectedOption &&
            !this.coleagues.find(
                (coleague) => coleague.id_user === selectedOption.id_user
            )
        ) {
            this.coleagues.push(selectedOption);
            this.coleagueInput.nativeElement.value = '';
            this.coleaguesCtrl.setValue(null);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([...this.coleagues]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    getUsersActive() {
        this.commonService
            .getUsersActive()
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.allColeagues = requestData;
            });
    }

    onFileSelected(event: any, section: any) {
        const files = event.target.files;
        if (files) {
            var filesArray;
            switch (section) {
                case 'cetatean':
                    filesArray = this.sendMessageCetateanForm.get('files') as FormArray;
                    break;

                case 'intern':
                    filesArray = this.sendMessageInternForm.get('files') as FormArray;
                    break;

                case 'nota':
                    filesArray = this.sendMessageNotitaForm.get('files') as FormArray;
                    break;
            }

            Array.from(files).forEach((file: any) => {
                if (!this.uploadedFileNames.includes(file.name)) {
                    this.uploadedFileNames.push(file.name);
                    const fileControl = new FormControl(file);

                    filesArray.push(fileControl);
                }
            });
        }
    }

    deleteFile(fileName: string, section: any) {
        const nameIndex = this.uploadedFileNames.indexOf(fileName);
        if (nameIndex > -1) {
            this.uploadedFileNames.splice(nameIndex, 1);
        }
        var filesArray: any;
        switch (section) {
            case 'cetatean':
                filesArray = this.sendMessageCetateanForm.get('files') as FormArray;
                break;

            case 'intern':
                filesArray = this.sendMessageInternForm.get('files') as FormArray;
                break;

            case 'nota':
                filesArray = this.sendMessageNotitaForm.get('files') as FormArray;
                break;
        }

        // const filesArray = this.sendMessageForm.get('files') as FormArray;
        const fileIndex = filesArray.controls.findIndex(
            (control: any) => control.value.name === fileName
        );
        if (fileIndex > -1) {
            filesArray.removeAt(fileIndex);
        }
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.cereriService.setToken(token);
            this.processUserDetails();
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onMessagingChange(event: MatButtonToggleChange) {
        this.selectedMessagingToggle = event.value;
    }

    resetAllForms() {
        if (this.sendMessageInternForm.value) {
            this.coleagues = [];
            this.sendMessageInternForm.get('message')?.setValue(null);
            this.sendMessageInternForm.get('type')?.setValue('2');
            this.sendMessageInternForm.get('notify')?.setValue(false);

            const filesFormArray = this.sendMessageInternForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageInternForm.clearValidators();
        }

        if (this.sendMessageCetateanForm.value) {
            this.sendMessageCetateanForm.get('message')?.setValue('');
            this.sendMessageCetateanForm.get('type')?.setValue('1');
            this.sendMessageCetateanForm.get('notify')?.setValue(false);
            this.notifyAnswer.get('notify_date_expire')?.setValue(null);

            const filesFormArray = this.sendMessageCetateanForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageCetateanForm.clearValidators();
        }

        if (this.sendMessageNotitaForm.value) {
            this.sendMessageNotitaForm.get('message')?.setValue('');
            this.sendMessageNotitaForm.get('type')?.setValue('3');
            this.sendMessageNotitaForm.get('notify')?.setValue(false);

            const filesFormArray = this.sendMessageNotitaForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageNotitaForm.clearValidators();
        }
    }

    submitMessage(section: any) {
        this.isLoading = true;

        var newMessage;
        switch (section) {
            case 'cetatean':
                newMessage = this.sendMessageCetateanForm
                    .value as RequestMessageToCetateanPayload;

                if (this.sendMessageCetateanForm.get('notify')?.value === true) {
                    newMessage = Object.assign(newMessage, {
                        notify_date_expire: this.notifyAnswer.value.notify_date_expire,
                    });
                }
                break;
            case 'intern':
                newMessage = this.sendMessageInternForm
                    .value as RequestMessageInternPayload;
                break;

            case 'nota':
                newMessage = this.sendMessageNotitaForm
                    .value as RequestMessageNotitaPayload;
                break;
        }

        this.cereriService
            .postMessage(this.cerere!.id_cerere, newMessage)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    this.uploadedFileNames = [];
                    this.resetAllForms();
                })
            )
            .subscribe({
                next: (res) => {
                    // this.isLoading = true;
                    // Commented the function below so that we dont have a popup when the loading spinner is active

                    // this.notificationService.warningSwal(
                    //   this.successTitle,
                    //   'Cerere actualizata cu succes!',
                    //   this.successIcon
                    // );
                    // refresh data please
                    this.getRequestInfo(false, false);

                    switch (section) {
                        case 'cetatean':
                            this.sendMessageCetateanForm.patchValue({
                                message: '',
                                files: [],
                            });
                            this.notifyAnswer.patchValue({
                                notify: false,
                                notify_date_expire: null,
                            });
                            break;

                        case 'intern':
                            this.sendMessageInternForm.patchValue({
                                message: '',
                                files: [],
                                coleagues: this.coleagues,
                            });
                            break;

                        case 'nota':
                            this.sendMessageNotitaForm.patchValue({
                                message: '',
                                files: [],
                            });
                            break;
                    }

                    // this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    confirmPreluarePersonala() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să preluați cererea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // this.isLoading = true;
                this.cereriService
                    .preluarePersonala(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            // this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Cerere preluată cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    confirmInValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.invalidate,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.invalidate,
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv de invalidare!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .invalidateCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    confirmAnulareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.clasare,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.cancel,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv..!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    confirmValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.validate,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .validateCerere(this.cerere!.id_cerere)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    openInchidereSolicitare(data: Cerere) {
        let dialogRef = this.dialog.open(ModalInchidereLucrareComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    addFileCetatean(event: any, key: 'file') {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageCetateanForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    addFileIntern(event: any, key: 'file') {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageInternForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    addFileNotita(event: any, key: 'file') {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            // const currentFiles = this.sendMessageNotitaForm.get('files')?.value || [];
                            // currentFiles.push(result.data);
                            // this.sendMessageNotitaForm.get('files')?.setValue(currentFiles);
                            const files = this.sendMessageNotitaForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    removeFileCetatean(index: number) {
        // const currentFiles = this.sendMessageCetateanForm.value.files || [];
        // const currentFiles = this.sendMessageCetateanForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageCetateanForm.patchValue({ files: currentFiles });

        const files = this.sendMessageCetateanForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileIntern(index: number) {
        // const currentFiles = this.sendMessageInternForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageInternForm.patchValue({ files: currentFiles });

        const files = this.sendMessageInternForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileNota(index: number) {
        // const currentFiles = this.sendMessageNotitaForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageNotitaForm.patchValue({ files: currentFiles });

        const files = this.sendMessageNotitaForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    isObjectEmpty(obj: any): boolean {
        return obj && Object.keys(obj).length === 0;
    }

    onCerereChanged(data: Cerere) {
        this.cerere = data;
        this.passedRequestId = this.cerere.id_cerere;
    }

    onIstoricChanged(istoric: HistoryEntry[]) {
        this.istoric = istoric;
    }

    onInfoExtraChange(event: MatButtonToggleChange) {
        this.selectedInfoExtra = event.value;
    }

    onPFInfoChange(event: MatButtonToggleChange) {
        this.selectedPFStatus = event.value;
    }

    showPreluareNumarRegistratura() {
        return (
            this.cerere?.id_user_assigned != null &&
            this.cerere?.id_user_assigned == this.user.id_user &&
            this.cerere?.reg_numar == null
            // &&
            // this.permissionsService.hasPermission(
            // 	'urbanism-module.cerere.generare_numar_solicitare_cerere'
            // )
        );
    }

    confirmPreluareNumarRegistratura() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Veți prelua un număr de registratură pentru solicitarea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluareNumarRegistratura(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Număr de registratură preluat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    openSabloane() {
        const dialogRef = this.dialog.open(SabloaneComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
        });

        dialogRef
            .afterClosed()
            .subscribe(({ success }: { success: boolean }) => { });
    }



    // special operations, we need to reset states of special activities on cerere
    resetValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea validarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message')
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, 'error from BE')
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetinValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea inValidarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message')
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetinValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, 'error from BE')
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetClasareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea clasarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message')
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetClasareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetInchidereCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea inchiderii de cerere? Confirmati anularea de inchidere a cerere in cadrul modulului de INDOC - Registratura?",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message')
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetInchidereCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, 'error from BE')
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    notificareCetateanDocumentOficial(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Doriți sã trimiteți/notificați cetățeanul privind documentul/documentele oficiale încărcate?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message')
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .sendNotificationCetateanDocumentOficial(documentId)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, 'error from BE')
                        Swal.showValidationMessage(`Eroare: ${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: false,
        })
            .then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: this.helper.swalTextConfig.headers.success,
                        text: 'Notificare trimisă cu succes!',
                        icon: 'success',
                        confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                    }).then(() => {
                        this.getRequestInfo();
                    });
                }
            });
    }

    getIstoric(boolean = true) {
        this.isLoading = boolean;
        this.cereriService
            .getMessages(this.passedRequestId)
            .pipe(map((res: any) => res.data))
            .subscribe((data) => {
                this.isLoading = false;
                this.istoric = data;
            })
    }

    onDocumentChange(event: MatButtonToggleChange) {
        this.selectedDocTypeKey = event.value;
    }

    openEditDialog(value: any) {
        let dialogRef = this.dialog.open(EditDialogComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                id_cerere: this.cerere?.id_cerere,
                value,
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: 'Succes!',
                    text: 'Email cetățean actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: 'Închide',
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }
}
